export class SignInMethodRedirect {
    constructor(redirect_uri, post_logout_redirect_uri) {
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
    }
}
export class SignInMethodPopUp {
    constructor(popup_redirect_uri, popup_post_logout_redirect_uri) {
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
    }
}
export const SilentRenewMixin = (signInMethod) => (uri) => {
    return Object.assign(signInMethod, {
        silent_redirect_uri: uri,
        automaticSilentRenew: false,
        validateSubOnSilentRenew: true
    });
};
export const SilentAutoRenewMixin = (signInMethod) => (uri) => {
    return Object.assign(signInMethod, {
        silent_redirect_uri: uri,
        automaticSilentRenew: true,
        validateSubOnSilentRenew: true
    });
};
//# sourceMappingURL=sign-in-methods.js.map